/**
 * Enums matching the AIMS backend OpenAPI schema.
 * Source: GET /api/v1/aims/schema/
 */

export enum AnalysisType {
  ADA = "ADA",
  LIA = "LIA",
}

export const ANALYSIS_TYPE_VALUES: AnalysisType[] = [AnalysisType.ADA, AnalysisType.LIA]

/**
 * ContractType — types attachable to a contract (and to a contract↔asset link).
 * Includes domain types beyond ADA/LIA.
 */
export enum ContractType {
  ADA = "ADA",
  LIA = "LIA",
  AD_HOC = "AD_HOC",
  COMMUNITY_INSIGHTS = "COMMUNITY_INSIGHTS",
}

export const CONTRACT_TYPE_VALUES: ContractType[] = [
  ContractType.ADA,
  ContractType.LIA,
  ContractType.AD_HOC,
  ContractType.COMMUNITY_INSIGHTS,
]

export const CONTRACT_TYPE_LABELS: Record<ContractType, string> = {
  [ContractType.ADA]: "ADA",
  [ContractType.LIA]: "LIA",
  [ContractType.AD_HOC]: "Ad hoc",
  [ContractType.COMMUNITY_INSIGHTS]: "Community insights",
}

export enum Source {
  MANUAL_INPUT = "Manual Input",
  EXCEL_UPLOAD = "Excel Upload",
}

/**
 * StartMonth / EndMonth enums.
 * The backend accepts both abbreviated and full month names.
 * We use the abbreviated form throughout the frontend.
 */
export const MONTH_VALUES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const

export type Month = (typeof MONTH_VALUES)[number]

/**
 * Full set of values the backend accepts (both abbreviated and full names).
 * Use this when validating input received from the API.
 */
export const MONTH_BACKEND_ACCEPTED = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const
